/**
 * Life expectancy table — months remaining for a person
 * who has just completed a given age (column "0" in the GUS release).
 *
 * The table is UNISEX — GUS/ZUS uses one table for both women and men.
 *
 * We always use the data from column 0, treating the user as if they have just completed
 * the given year of age; the following columns, numbered 1, 2, 3, etc.,
 * correspond to each subsequent completed month — the full Excel file contains
 * life expectancy values for every completed month of age.
 *
 * Source: Announcement of the President of GUS regarding the table of average further
 * life expectancy for women and men (applies from April 1st each year).
 *
 */


// TODO: Read the data from a file (?)
export const LIFE_EXPECTANCY_MONTHS: Record<number, number> = {
  30: 594.8,
  31: 583.3,
  32: 571.8,
  33: 560.4,
  34: 548.9,
  35: 537.5,
  36: 526.2,
  37: 514.8,
  38: 503.5,
  39: 492.2,
  40: 481.0,
  41: 469.8,
  42: 458.6,
  43: 447.5,
  44: 436.4,
  45: 425.4,
  46: 414.4,
  47: 403.4,
  48: 392.5,
  49: 381.7,
  50: 370.9,
  51: 360.2,
  52: 349.7,
  53: 339.2,
  54: 328.8,
  55: 318.6,
  56: 308.4,
  57: 298.3,
  58: 288.5,
  59: 278.6,
  60: 268.9,
  61: 259.4,
  62: 250.0,
  63: 240.7,
  64: 231.7,
  65: 222.7,
  66: 214.1,
  67: 205.4,
  68: 197.0,
  69: 188.8,
  70: 180.6,
  71: 172.6,
  72: 164.6,
  73: 156.8,
  74: 149.2,
  75: 141.7,
  76: 134.3,
  77: 127.1,
  78: 120.0,
  79: 113.2,
  80: 106.4,
  81: 100.0,
  82: 93.7,
  83: 87.7,
  84: 82.0,
  85: 76.6,
  86: 71.5,
  87: 66.7,
  88: 62.3,
  89: 58.1,
  90: 54.2,
};
